export default "__VITE_ASSET__DQmP2Ibl__"